// import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import RightSidebar from "./RightSidebar";
import { useState } from "react";

const DashboardLayout = ({
  children,
  topBarRight,
  onCreatePost,
  disableScrollRestriction = false,
}) => {
  const location = useLocation();

  const hideRightSidebar =
    location.pathname !== "/community" &&
    location.pathname !== "/mentorship" &&
    location.pathname !== "/pilgrim-membership" &&
    location.pathname !== "/faith-stream" &&
    location.pathname !== "/home";

  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-surface">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        >
          <div className="absolute inset-0 bg-black/40" />
        </div>
      )}

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-50 transform transition-transform duration-300 lg:relative lg:translate-x-0 lg:z-auto ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      <div
        className={`flex flex-1 flex-col min-w-0 ${
          disableScrollRestriction ? "" : "overflow-hidden"
        }`}
      >
        <TopBar
          rightContent={topBarRight}
          onCreatePost={onCreatePost}
          onMenuToggle={() => setSidebarOpen(true)}
        />

        <div className="flex flex-1 min-h-0">
          {children}

          {!hideRightSidebar && (
            <div className="hidden xl:block flex-shrink-0 h-[calc(100vh-56px)]">
              <RightSidebar />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;